import React, { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { verificarStatusPagamento } from '../../api/vehicleAPI';
import { FaSpinner } from 'react-icons/fa';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 15px;
  background: ${({ theme }) => theme.colors.light};
  border-radius: ${({ theme }) => theme.radii.md};
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 600;
  width: 100%;
  
  svg {
    animation: ${spin} 1s linear infinite;
  }
`;

const PaymentStatus = ({ paymentId, onSuccess }) => {
  const POLLING_INTERVAL = 10000; // 10 segundos
  const MAX_ATTEMPTS = 180; // 30 minutos (180 tentativas * 10s)
  
  const [attempts, setAttempts] = useState(0);
  // Usamos useRef para guardar o ID do timeout sem causar re-renderizações
  const timeoutIdRef = useRef(null);

  useEffect(() => {
    // Função que faz a verificação e agenda a próxima
    const pollStatus = async () => {
      if (!paymentId || attempts >= MAX_ATTEMPTS) {
        return; // Para a verificação se não houver ID ou se exceder as tentativas
      }

      try {
        const response = await verificarStatusPagamento(paymentId);
        
        // Verifica se o status é 'paid'
        if (response && Array.isArray(response) && response[0]?.status === 'paid') {
          onSuccess(); // Chama a função de sucesso e para o polling
          return;
        }

      } catch (error) {
        console.error("Erro ao verificar status do pagamento:", error);
        // Em caso de erro, paramos o polling para não sobrecarregar o servidor
        return;
      }
      
      // Se não for 'paid' e não deu erro, incrementa a tentativa e agenda a próxima
      const nextAttempt = attempts + 1;
      setAttempts(nextAttempt);
      
      // Agenda a PRÓXIMA chamada apenas se não tivermos atingido o limite
      if (nextAttempt < MAX_ATTEMPTS) {
          timeoutIdRef.current = setTimeout(pollStatus, POLLING_INTERVAL);
      }
    };

    // Inicia a primeira verificação
    pollStatus();

    // Função de limpeza: será chamada quando o componente for desmontado
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
    // A dependência 'attempts' garante que a lógica é reavaliada a cada tentativa
  }, [paymentId, onSuccess, attempts]);

  return (
    <StatusWrapper>
      <FaSpinner />
      Aguardando Pagamento...
    </StatusWrapper>
  );
};

export default PaymentStatus;